import { SelectionChangedEvent } from "ag-grid-community";
import { ShiftEntity } from "domain/entity/Shift/ShiftEntity";
import _ from "lodash";
import { INITIAL_SHIFT_COL_DEF } from "presentation/constant/Shift/ShiftMaintenanceColumnDefinition";
import { ShiftMaintenanceConstant } from "presentation/constant/Shift/ShiftMaintenanceConstant";
import { useShiftMaintenanceVM } from "presentation/hook/Shift/useShiftMaintenanceVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useShiftMaintenanceTracked } from "presentation/store/Shift/ShiftMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef } from "react";
const ShiftTablePanel: React.FC = () => {
    const [shiftState] = useShiftMaintenanceTracked();
    const shiftVM = useShiftMaintenanceVM();
    const gridRef: any = useRef(null);
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        shiftVM.updateSelectedRows(selectedRows);
    }, [shiftVM])

    const handleAddClick = useCallback(() => {
        shiftVM.onAdd();
    }, [shiftVM])

    const handleRowDoubleClick = useCallback((entity: ShiftEntity) => {
        shiftVM.onEdit(entity);
    }, [shiftVM])

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(shiftState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [rightClickRef, allowUpdate, shiftState.selectedRows]);

    const memoTable = useMemo(() => {
        return (
            <>
                {/* {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />} */}
                <div id="myDiv">
                    <NbisTable
                        id='shift-code-table'
                        headerLabel={ShiftMaintenanceConstant.TITLE}
                        isNewColumnSetting={true}
                        columns={INITIAL_SHIFT_COL_DEF}
                        data={shiftState.tableData ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        onAddClick={handleAddClick}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: ShiftEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        rowSelection={"single"}

                    />
                </div>
            </>
        );
    }, [shiftState.tableData, allowCreate, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    return <><TableWrapper>
        {memoTable}
        {shiftState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}
export default memo(ShiftTablePanel); 
